<template>
  <div>
    <div
      :class="{ model: true, modelShow: value1, modelHidden: !value1 }"
      :style="{ opacity: value1 ? 1 : 0, 'z-index': value1 ? 10 : -2, height }"
      @click.stop="close"
    ></div>
    <div
      :class="{ content: true, contentShow: value1, contentHidden: !value1}"
      :style="{ bottom: value1 ? 0 : '-200px' }"
    >
      <slot name="content" @click.stop="eventHandler" />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      value1: this.value
    }
  },
  methods: {
    close () {
      this.value1 = false
      setTimeout(() => {
        this.$emit('input', this.value1)
      }, 500)
    },
    goCreate () {
      this.$emit('click')
    }
  },
  watch: {
    value (val) {
      this.value1 = val
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes contentShow{
  from {
    bottom: -200px;
  }
  to {
    bottom: 0;
  }
}
@keyframes contentHidden {
  from {
    bottom: 0;
  }
  to {
    bottom: -200px;
  }
}
@keyframes modelShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modelHidden {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.modelShow {
  animation: modelShow linear 0.3s;
}
.modelHidden {
  animation: modelHidden linear 0.3s;
}
.contentShow {
  animation: contentShow linear 0.3s;
}
.contentHidden {
  animation: contentHidden linear 0.3s;
}

.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform:translateZ(1px);
  z-index: 10;
  opacity: 0;
  background: rgba(0, 0, 0, 0.4);
}
.content {
  width: 100%;
  position: fixed;
  transform:translateZ(1px);
  bottom: 0;
  left: 0;
  z-index: 99;
}
</style>
